import { render, staticRenderFns } from "./ReportCheckListText.vue?vue&type=template&id=ab35670e&scoped=true&"
import script from "./ReportCheckListText.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListText.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListText.vue?vue&type=style&index=0&id=ab35670e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab35670e",
  null
  
)

export default component.exports
import {QCardSection,QItem,QInput} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem,QInput}, component.options.components || {})
